import Container from "./Container";
import Text from "./Text";

export interface IInsightItemProps {
    title: string;
    children: React.ReactNode;
}

export default function InsightItem(props: IInsightItemProps) {
    const { title, children } = props;

    return (   
        <Container flexColumn gap={2} className="flex-1 mt-4">
            <Text color="900" className="text-left text-lg font-bold">{title}</Text>
            <Text color="600" className="text-left text-lg ml-4 font-light">{children}</Text>
        </Container>
    )
}